<template>
  <section class="form-list">
    <el-form
      ref="form"
      :rules="rules"
      :model="salary"
      label-position="left"
      label-width="160px"
      style="width: 520px; margin-left:50px;"
    >
      <el-form-item label="管理员">
        <v-avatar-nickname :value="administrator.avatar" :nickname="administrator.nickname"/>
      </el-form-item>

      <el-form-item v-if="isAdministrator" label="所属门店">
        {{ administrator.store_name | formatStoreName }}
      </el-form-item>

      <el-form-item label="职位" prop="administrator_role_id">
        <v-select-administrator-role class="w100" v-model="salary.administrator_role_id"/>
      </el-form-item>

      <el-form-item label="底薪">
        <v-input-money class="w100" :max="99999.99" v-model="salary.base_pay"/>
      </el-form-item>
      <el-form-item label="公司社保">
        <v-input-money class="w100" :max="99999.99" v-model="salary.social_insurance"/>
      </el-form-item>
      <el-form-item label="个人社保">
      <el-form-item label="门店社保">
        <v-input-money class="w100" :max="99999.99" v-model="salary.store_insurance"/>
      </el-form-item>

        <v-input-money class="w100" :max="99999.99" v-model="salary.personal_insurance"/>
      </el-form-item>

      <el-form-item label="业绩任务">
        <v-input-money class="w100" :max="999999.99" v-model="salary.task_income"/>
      </el-form-item>
      <el-form-item label="未完成底薪比例">
        <v-input-money class="w100" v-model="salary.base_pay_rate"/>
      </el-form-item>
      <el-form-item label="完成后提成比例">
        <v-input-money class="w100" v-model="salary.commission_rate"/>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="handleSubmit" :loading="isSaving">保存修改</el-button>
        <el-button @click="RouteConfig.administratorSalaryList.back">取消</el-button>
      </el-form-item>
    </el-form>
  </section>
</template>

<script>
  import RouteConfig from "@/router/config";
  import { mapGetters } from 'vuex';
  import { show, update } from '@/api/administratorRoleMerge';
  import { toCent, toYuan } from '@/filters';

  export default {
    name: RouteConfig.administratorSalaryEdit.name,
    data: () => ({
      RouteConfig,
      isSaving: false,
      administrator: {
        nickname: '',
        avatar: '',
        store_name: '',
      },
      salary: {
        administrator_id: 0,
        store_id: 0,
        administrator_role_id: 0,
        base_pay: 0,
        social_insurance: 0,
        personal_insurance: 0,
        task_income: 0,
        store_insurance: 0,

        base_pay_rate: 0,
        commission_rate: 0,
      },
      rules: {
        store_id: [{required: true, message: '请选择所属门店', trigger: 'change'}],
        administrator_role_id: [{ required: true, message: '请选择职位', trigger: 'change' }],
      },
    }),
    computed: {
      ...mapGetters([
        'isAdministrator',
      ]),
      id() {
        return +this.$route.params.id || 0;
      },
    },
    beforeMount() {
      this.show();
    },
    methods: {
      async show() {
        const { isError, data } = await show(this.id);
        if (isError) return;

        const { administrator, salary } = this;
        Object.keys(data).forEach(key => {
          if (key in administrator) administrator[key] = data[key];
        });

        Object.assign(salary, {
          administrator_role_id: data.administrator_role_id || 0,
          base_pay: toYuan(data.base_pay),
          social_insurance: toYuan(data.social_insurance),
          store_insurance: toYuan(data.store_insurance),

          personal_insurance: toYuan(data.personal_insurance),
          task_income: toYuan(data.task_income),
          base_pay_rate: toYuan(data.base_pay_rate),
          commission_rate: toYuan(data.commission_rate),
        });
      },
      handleSubmit() {
        if (this.isSaving) return;

        this.$refs.form.validate(async (isSuccess) => {
          if (!isSuccess) return;

          this.isSaving = true;

          const postData = { ...this.salary };
          postData.base_pay = toCent(postData.base_pay);
          postData.store_insurance = toCent(postData.store_insurance);

          postData.social_insurance = toCent(postData.social_insurance);
          postData.personal_insurance = toCent(postData.personal_insurance);
          postData.task_income = toCent(postData.task_income);
          postData.base_pay_rate = toCent(postData.base_pay_rate);
          postData.commission_rate = toCent(postData.commission_rate);

          const { isError } = await update(this.id, postData);
          this.isSaving = false;
          if (isError) return;

          RouteConfig.administratorSalaryList.push();
        });
      },

    },
  };
</script>
